module.exports = __webpack_public_path__ + "img/star-black.8e380624.svg";